"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log ke console
    console.error("[GLOBAL ERROR]", error);

    // Kirim log ke file via API
    fetch("/api/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        level: "ERROR",
        message: `[GLOBAL ERROR] ${error.message}`,
        data: {
          digest: error.digest,
          stack: error.stack,
        },
      }),
    }).catch(() => {
      // Ignore fetch errors
    });

    // Auto-reload jika ChunkLoadError (setelah deploy baru)
    if (
      error.message.includes("Loading chunk") ||
      error.message.includes("ChunkLoadError") ||
      error.name === "ChunkLoadError"
    ) {
      // Reload halaman untuk mendapat versi terbaru
      window.location.reload();
    }
  }, [error]);

  return (
    <div className="bg-forest">
      <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
        <h1 className="text-4xl font-bold text-red-700 shadow-sm">
          500 - Server Error
        </h1>
        <p className="text-gray-600 mt-4">
          {error.message || "Something went wrong."}
        </p>
        <button
          onClick={() => reset()}
          className="mt-6 px-4 py-2 bg-blue-500 text-white rounded-md"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
